/* Auto-extracted from 'Alterations Code Generator' Data Source sheet. */
/* eslint-disable */
export const CODEGEN_TABLES = {
 "subCategory": [
  {
   "code": "AC",
   "desc": "Accessory & Components"
  },
  {
   "code": "BT",
   "desc": "Batten"
  },
  {
   "code": "BL",
   "desc": "Bollard"
  },
  {
   "code": "CL",
   "desc": "Cabinet & Showcase"
  },
  {
   "code": "DR",
   "desc": "Downlight Recessed"
  },
  {
   "code": "EC",
   "desc": "Electronics & Lighting Control"
  },
  {
   "code": "EL",
   "desc": "Exit & Emergency"
  },
  {
   "code": "FLS",
   "desc": "Flexible Led Strip & Aluminium Profile"
  },
  {
   "code": "FL",
   "desc": "Floodlight"
  },
  {
   "code": "FS",
   "desc": "Free-Standing Luminaire"
  },
  {
   "code": "GD",
   "desc": "Garden"
  },
  {
   "code": "GM",
   "desc": "Ground Mount"
  },
  {
   "code": "HB",
   "desc": "Highbay, Lowbay& Canopy"
  },
  {
   "code": "IG",
   "desc": "In-Ground"
  },
  {
   "code": "CO",
   "desc": "Lamps, Bulbs, Globes, Tubes"
  },
  {
   "code": "LN",
   "desc": "Recessed Linear"
  },
  {
   "code": "LNSM",
   "desc": "Surface Mounted Linear"
  },
  {
   "code": "LNSP",
   "desc": "Suspended Linear"
  },
  {
   "code": "LNWM",
   "desc": "Wall Mounted Linear"
  },
  {
   "code": "NL",
   "desc": "Non-Lighting Item"
  },
  {
   "code": "PA",
   "desc": "Panel"
  },
  {
   "code": "SP",
   "desc": "Pendant"
  },
  {
   "code": "SPL",
   "desc": "Spot Light"
  },
  {
   "code": "PS",
   "desc": "Power Supply Unit"
  },
  {
   "code": "SOL",
   "desc": "Solar"
  },
  {
   "code": "SL",
   "desc": "Street Light"
  },
  {
   "code": "SM",
   "desc": "Surface Mounted"
  },
  {
   "code": "TKC",
   "desc": "Track & Components"
  },
  {
   "code": "TRNK",
   "desc": "Trunking System"
  },
  {
   "code": "ST",
   "desc": "Track Mounted Luminaire"
  },
  {
   "code": "SR",
   "desc": "Downlight Recessed Adjustable"
  },
  {
   "code": "TR",
   "desc": "Troffer"
  },
  {
   "code": "USL",
   "desc": "USA Strip Lighting (USA TEAM ONLY)"
  },
  {
   "code": "UW",
   "desc": "Underwater Light"
  },
  {
   "code": "WL",
   "desc": "Wall Light"
  }
 ],
 "revSubCategory": [
  {
   "code": "DR",
   "desc": "Recessed Fixed"
  },
  {
   "code": "SR",
   "desc": "Recessed Adjustable"
  },
  {
   "code": "DP",
   "desc": "Pendant Fixed"
  },
  {
   "code": "SP",
   "desc": "Pendant Adjustable"
  },
  {
   "code": "DS",
   "desc": "Surface Fixed"
  },
  {
   "code": "SS",
   "desc": "Surface Adjustable"
  },
  {
   "code": "ST",
   "desc": "Track Spot"
  },
  {
   "code": "TKC",
   "desc": "Track & Components"
  },
  {
   "code": "TR",
   "desc": "Troffer"
  },
  {
   "code": "PA",
   "desc": "Panel"
  },
  {
   "code": "LN",
   "desc": "Linear Recessed"
  },
  {
   "code": "LNSM",
   "desc": "Linear Surface Mounted"
  },
  {
   "code": "LNSP",
   "desc": "Linear Suspended"
  },
  {
   "code": "LNWM",
   "desc": "Linear Wall Mounted"
  },
  {
   "code": "WA",
   "desc": "Wall Light​​​​​​​"
  },
  {
   "code": "PS",
   "desc": "Power Supply Unit"
  },
  {
   "code": "EC",
   "desc": "Electronics & Lighting Control"
  },
  {
   "code": "EL",
   "desc": "Exit & Emergency"
  },
  {
   "code": "FLS",
   "desc": "Flexible Led Strip & Aluminium Profile"
  },
  {
   "code": "AC",
   "desc": "Accessory & Components"
  },
  {
   "code": "BT",
   "desc": "Batten"
  },
  {
   "code": "BL",
   "desc": "Bollard"
  },
  {
   "code": "CL",
   "desc": "Cabinet & Showcase"
  },
  {
   "code": "FL",
   "desc": "Floodlight"
  },
  {
   "code": "FS",
   "desc": "Free-Standing Luminaire"
  },
  {
   "code": "GD",
   "desc": "Garden"
  },
  {
   "code": "GM",
   "desc": "Ground Mount"
  },
  {
   "code": "HB",
   "desc": "Highbay, Lowbay& Canopy"
  },
  {
   "code": "IG",
   "desc": "In-Ground"
  },
  {
   "code": "CO",
   "desc": "Lamps, Bulbs, Globes, Tubes"
  },
  {
   "code": "NL",
   "desc": "Non-Lighting Item"
  },
  {
   "code": "SOL",
   "desc": "Solar"
  },
  {
   "code": "SL",
   "desc": "Street Light"
  },
  {
   "code": "WS",
   "desc": "WideSky"
  },
  {
   "code": "IS2",
   "desc": "48V - Powergear"
  },
  {
   "code": "IS5",
   "desc": "48V - Isse V"
  },
  {
   "code": "ISX",
   "desc": "Non Stock 48V System"
  },
  {
   "code": "MDR",
   "desc": "Modurail Compatiable"
  },
  {
   "code": "MDR8",
   "desc": "Modurail 8 Wire"
  },
  {
   "code": "MDR13",
   "desc": "Modurail 13 Wire"
  },
  {
   "code": "TRNK",
   "desc": "Non Stock Trunking System"
  }
 ],
 "heads": [
  {
   "code": "",
   "desc": "Single Head"
  },
  {
   "code": "2",
   "desc": "2 Way Mutiple head"
  },
  {
   "code": "3",
   "desc": "3 Way Mutiple head"
  }
 ],
 "shape": [
  {
   "code": "R",
   "desc": "Round"
  },
  {
   "code": "S",
   "desc": "Square"
  }
 ],
 "size": [
  {
   "code": "XS",
   "desc": "Extra Small"
  },
  {
   "code": "S",
   "desc": "Small"
  },
  {
   "code": "M",
   "desc": "Medium"
  },
  {
   "code": "L",
   "desc": "Large"
  },
  {
   "code": "XL",
   "desc": "Extra Large"
  }
 ],
 "trim": [
  {
   "code": "",
   "desc": "Trimmed"
  },
  {
   "code": "T",
   "desc": "Trimless"
  }
 ],
 "chip": [
  {
   "code": "A",
   "desc": "Cree CXA"
  },
  {
   "code": "B",
   "desc": "Cree CXB"
  },
  {
   "code": "C",
   "desc": "Citizen"
  },
  {
   "code": "D",
   "desc": "Edison Opto"
  },
  {
   "code": "E",
   "desc": "Epistar/Certaflux (Phillips)"
  },
  {
   "code": "F",
   "desc": "Guineg"
  },
  {
   "code": "G",
   "desc": "Bridgelux"
  },
  {
   "code": "H",
   "desc": "Hongli"
  },
  {
   "code": "I",
   "desc": "LG Innotek"
  },
  {
   "code": "J",
   "desc": "Tipicled"
  },
  {
   "code": "K",
   "desc": "Lumens AC"
  },
  {
   "code": "L",
   "desc": "Luminus"
  },
  {
   "code": "M",
   "desc": "Cree CMA"
  },
  {
   "code": "N",
   "desc": "Nichia"
  },
  {
   "code": "O",
   "desc": "Osram"
  },
  {
   "code": "P",
   "desc": "Phillips"
  },
  {
   "code": "Q",
   "desc": "CREE CMB Pro 9"
  },
  {
   "code": "R",
   "desc": "Soraa"
  },
  {
   "code": "S",
   "desc": "Samsung"
  },
  {
   "code": "T",
   "desc": "LED Teen"
  },
  {
   "code": "U",
   "desc": "Lumileds (Phillips)"
  },
  {
   "code": "V",
   "desc": "Vivid"
  },
  {
   "code": "W",
   "desc": "CREE CMB"
  },
  {
   "code": "X",
   "desc": "Sanan Optoelectronics"
  },
  {
   "code": "Y",
   "desc": "Toyoda Gosel"
  },
  {
   "code": "Z",
   "desc": "Cree XPG2"
  },
  {
   "code": "1",
   "desc": "Other"
  }
 ],
 "cri": [
  {
   "code": "70",
   "desc": "CRI 70"
  },
  {
   "code": "80",
   "desc": "CRI 80"
  },
  {
   "code": "90",
   "desc": "CRI 90"
  },
  {
   "code": "95",
   "desc": "CRI 95"
  },
  {
   "code": "97",
   "desc": "CRI 97"
  }
 ],
 "cct": [
  {
   "code": "27",
   "desc": "2700K"
  },
  {
   "code": "30",
   "desc": "3000K"
  },
  {
   "code": "35",
   "desc": "3500K"
  },
  {
   "code": "40",
   "desc": "4000K"
  },
  {
   "code": "50",
   "desc": "5000K"
  },
  {
   "code": "60",
   "desc": "6000K"
  },
  {
   "code": "SW",
   "desc": "Switchable"
  },
  {
   "code": "TU",
   "desc": "Tuneable"
  },
  {
   "code": "RG",
   "desc": "RGB"
  },
  {
   "code": "RW",
   "desc": "RGBW"
  },
  {
   "code": "NS",
   "desc": "NONE"
  },
  {
   "code": "1830",
   "desc": "Dim to Warm"
  },
  {
   "code": "2765",
   "desc": "Tunable White"
  }
 ],
 "optical": [
  {
   "code": "R",
   "desc": "Reflector"
  },
  {
   "code": "L",
   "desc": "Lens"
  },
  {
   "code": "MP",
   "desc": "Microprismatic"
  },
  {
   "code": "MPH",
   "desc": "MPRM+UGR Film"
  },
  {
   "code": "OP",
   "desc": "Opal PMMA"
  },
  {
   "code": "PC",
   "desc": "Polycarbonate Diffuser"
  },
  {
   "code": "LO",
   "desc": "Louvre"
  }
 ],
 "finish": [
  {
   "code": "WH",
   "desc": "White"
  },
  {
   "code": "BK",
   "desc": "Black"
  },
  {
   "code": "GR",
   "desc": "Grey"
  },
  {
   "code": "SL",
   "desc": "Silver"
  },
  {
   "code": "AL",
   "desc": "Aluminium"
  },
  {
   "code": "GD",
   "desc": "Gold"
  },
  {
   "code": "CP",
   "desc": "Copper"
  },
  {
   "code": "BZ",
   "desc": "Bronze"
  },
  {
   "code": "CG",
   "desc": "Champagne Gold"
  },
  {
   "code": "CH",
   "desc": "Chrome"
  },
  {
   "code": "GW",
   "desc": "Gloss White"
  },
  {
   "code": "RD",
   "desc": "Red"
  },
  {
   "code": "BL",
   "desc": "Blue"
  },
  {
   "code": "CL",
   "desc": "Clear"
  },
  {
   "code": "GN",
   "desc": "Green"
  },
  {
   "code": "SS",
   "desc": "Stainless Steel"
  },
  {
   "code": "YL",
   "desc": "Yellow"
  },
  {
   "code": "OT",
   "desc": "Other"
  },
  {
   "code": "WB",
   "desc": "White Trim / Black Inner"
  },
  {
   "code": "WG",
   "desc": "White Trim / Grey Inner"
  },
  {
   "code": "BW",
   "desc": "Black Trim / White Inner"
  },
  {
   "code": "BG",
   "desc": "Black Trim / Grey Inner"
  },
  {
   "code": "WD",
   "desc": "White Trim/Gold Inner"
  }
 ],
 "bezel": [
  {
   "code": "A",
   "desc": "Aluminium"
  },
  {
   "code": "B",
   "desc": "Black"
  },
  {
   "code": "C",
   "desc": "Copper"
  },
  {
   "code": "E",
   "desc": "Gold"
  },
  {
   "code": "F",
   "desc": "Bronze"
  },
  {
   "code": "G",
   "desc": "Grey"
  },
  {
   "code": "H",
   "desc": "Red"
  },
  {
   "code": "I",
   "desc": "Blue"
  },
  {
   "code": "J",
   "desc": "Clear"
  },
  {
   "code": "K",
   "desc": "Green"
  },
  {
   "code": "L",
   "desc": "Yellow"
  },
  {
   "code": "P",
   "desc": "Pale Umber (champagne gold)"
  },
  {
   "code": "R",
   "desc": "Rubra (red)"
  },
  {
   "code": "S",
   "desc": "Silver Denarius"
  },
  {
   "code": "T",
   "desc": "Brushed Steel"
  },
  {
   "code": "U",
   "desc": "Brushed Ravenna Bronze"
  },
  {
   "code": "V",
   "desc": "Satin Ravenna Bronze"
  },
  {
   "code": "W",
   "desc": "White"
  },
  {
   "code": "X",
   "desc": "Custom Ral"
  },
  {
   "code": "Y",
   "desc": "Black Chrome"
  },
  {
   "code": "Z",
   "desc": "Chrome"
  }
 ],
 "accessories": [
  {
   "code": "AG",
   "desc": "Anti Ligature"
  },
  {
   "code": "AS",
   "desc": "Asymmetric"
  },
  {
   "code": "BF",
   "desc": "Baffle"
  },
  {
   "code": "BD",
   "desc": "Barn Door"
  },
  {
   "code": "CD",
   "desc": "Clear Diffuser"
  },
  {
   "code": "CG",
   "desc": "Clear Glass"
  },
  {
   "code": "IC",
   "desc": "Clear IP Rated Lens"
  },
  {
   "code": "CL",
   "desc": "Cross Louver"
  },
  {
   "code": "CF",
   "desc": "Custom Filter"
  },
  {
   "code": "LE",
   "desc": "Custom Lens"
  },
  {
   "code": "ER",
   "desc": "Emergency Relay"
  },
  {
   "code": "FD",
   "desc": "Frosted Diffuser"
  },
  {
   "code": "FG",
   "desc": "Frosted Glass"
  },
  {
   "code": "FL",
   "desc": "Frosted Lens"
  },
  {
   "code": "GL",
   "desc": "Glass Cover"
  },
  {
   "code": "HC",
   "desc": "Honeycomb Louver"
  },
  {
   "code": "LS",
   "desc": "Lens and Snoot"
  },
  {
   "code": "OL",
   "desc": "Opal Spreader Lens"
  },
  {
   "code": "PR",
   "desc": "Prismatic Diffuser"
  },
  {
   "code": "RE",
   "desc": "Reeded Diffuser"
  },
  {
   "code": "SO",
   "desc": "Solite (Soft Focus Lens)"
  },
  {
   "code": "IS",
   "desc": "Solite IP Rated Lens"
  },
  {
   "code": "EL",
   "desc": "Elliptical Lens"
  },
  {
   "code": "SL",
   "desc": "Spread Lens"
  },
  {
   "code": "SY",
   "desc": "Symmetric"
  },
  {
   "code": "WW",
   "desc": "Wall Washer"
  },
  {
   "code": "IP",
   "desc": "IP54 / Damp"
  },
  {
   "code": "ID",
   "desc": "Integral Driver"
  },
  {
   "code": "WE",
   "desc": "Weiland Connector"
  }
 ],
 "dimming": [
  {
   "code": "ND",
   "desc": "Non-Dim"
  },
  {
   "code": "PD",
   "desc": "Phase-Cut / Triac"
  },
  {
   "code": "DD",
   "desc": "Dali"
  },
  {
   "code": "DD",
   "desc": "Dali-2"
  },
  {
   "code": "VD",
   "desc": "0-10V"
  },
  {
   "code": "VD",
   "desc": "1-10V"
  },
  {
   "code": "DX",
   "desc": "DMX"
  },
  {
   "code": "LU",
   "desc": "Lutron"
  },
  {
   "code": "XX",
   "desc": "No Driver"
  },
  {
   "code": "TR",
   "desc": "Triac"
  },
  {
   "code": "CD",
   "desc": "Casambi"
  }
 ],
 "outerTrim": [
  {
   "code": "",
   "desc": "Aluminium"
  },
  {
   "code": "",
   "desc": "Black"
  },
  {
   "code": "",
   "desc": "Copper"
  },
  {
   "code": "",
   "desc": "Gold"
  },
  {
   "code": "",
   "desc": "Bronze"
  },
  {
   "code": "",
   "desc": "Grey"
  },
  {
   "code": "",
   "desc": "Red"
  },
  {
   "code": "",
   "desc": "Blue"
  },
  {
   "code": "",
   "desc": "Clear"
  },
  {
   "code": "",
   "desc": "Green"
  },
  {
   "code": "",
   "desc": "Yellow"
  },
  {
   "code": "",
   "desc": "Pale Umber (champagne gold)"
  },
  {
   "code": "",
   "desc": "Rubra (red)"
  },
  {
   "code": "",
   "desc": "Silver Denarius"
  },
  {
   "code": "",
   "desc": "Brushed Steel"
  },
  {
   "code": "",
   "desc": "Brushed Ravenna Bronze"
  },
  {
   "code": "",
   "desc": "Satin Ravenna Bronze"
  },
  {
   "code": "",
   "desc": "White"
  },
  {
   "code": "",
   "desc": "Custom Ral"
  },
  {
   "code": "",
   "desc": "Black Chrome"
  },
  {
   "code": "",
   "desc": "Chrome"
  }
 ],
 "ip": [
  {
   "code": "IP20",
   "desc": "IP20"
  },
  {
   "code": "IP40",
   "desc": "IP40"
  },
  {
   "code": "IP41",
   "desc": "IP41"
  },
  {
   "code": "IP44",
   "desc": "IP44"
  },
  {
   "code": "IP54",
   "desc": "IP54"
  },
  {
   "code": "IP65",
   "desc": "IP65"
  },
  {
   "code": "IP66",
   "desc": "IP66"
  },
  {
   "code": "IP67",
   "desc": "IP67"
  },
  {
   "code": "IP68",
   "desc": "IP68"
  },
  {
   "code": "IP69",
   "desc": "IP69"
  }
 ],
 "ik": [
  {
   "code": "IK00",
   "desc": "IK00"
  },
  {
   "code": "IK01",
   "desc": "IK01"
  },
  {
   "code": "IK02",
   "desc": "IK02"
  },
  {
   "code": "IK03",
   "desc": "IK03"
  },
  {
   "code": "IK04",
   "desc": "IK04"
  },
  {
   "code": "IK05",
   "desc": "IK05"
  },
  {
   "code": "IK06",
   "desc": "IK06"
  },
  {
   "code": "IK07",
   "desc": "IK07"
  },
  {
   "code": "IK08",
   "desc": "IK08"
  },
  {
   "code": "IK09",
   "desc": "IK09"
  },
  {
   "code": "IK10",
   "desc": "IK10"
  }
 ]
};
